import { resolveGameRouteSlug } from '@core/utils/resolveGameRouteSlug';
import { buildGameRegistry } from './manifest-loader';

export type {
  AppGameControllerModule,
  AppGameRegistryEntry,
  GameAssetModule,
  GameControllerModule,
  GameManifest,
  GameRegistryEntry,
} from './game-registry-types';

export {
  assertManifestRegistryValid,
  buildGameRegistry,
  getCoreManifest,
  getGameManifest,
  listEnabledGameManifests,
  listGameManifests,
  resolveControllerImport,
} from './manifest-loader';

/** Built from current/games/*.json manifests at module load. */
export const gameRegistry = buildGameRegistry();

export function getGameRegistryEntry(
  slug: string
): import('./game-registry-types').AppGameRegistryEntry | null {
  return gameRegistry[resolveGameRouteSlug(slug)] ?? gameRegistry[slug] ?? null;
}
